<template>
  <div id="app">
    <loading v-show="loading"></loading>
    <Header></Header>
    <!-- 路由视图，由路由管理器分析hash地址的值，显示对应的vue组件 -->
    <router-view></router-view>
    <Player />
    <Login />
    <Footer></Footer>
    <el-backtop
      :visibility-height="500"
      :right="0"
      :bottom="100"
      class="backtop"
    >
      <el-tooltip
        class="item"
        effect="dark"
        content="回到顶部"
        placement="left"
      >
        <i class="el-icon-arrow-up"></i>
      </el-tooltip>
    </el-backtop>
  </div>
</template>

<script>
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";
import Player from "./components/common/Player.vue";
import Login from "@/views/Login/index.vue";
import loading from "@/components/loading/index.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    Header,
    Player,
    Login,
    Footer,
    loading,
  },
  computed: {
    ...mapGetters(["loading"]),
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
}
.backtop {
  color: #fff !important;
  background-color: #000 !important;
  opacity: 0.4 !important;
  border-radius: 0 !important;
}
</style>
